
export default {
  head() {
    return {
      title: this.initdata.metatitle,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.initdata.metadesc,
        }
      ],
    }
  },

  data() {
    return {
      initdata: {},
    };
  },

  mounted() {
    let options = {}

    if (process.client) {
      if (sessionStorage.options) {
        options = JSON.parse(sessionStorage.options)
        this.$root.$emit('set_saved_filters', options)
      }
      else {
        this.$root.$emit('go_without_filters')
      }
    }
  },

  asyncData(context) {
    // console.log('cat1')
    var initial_params = {}
    if (context.route.query.language) {
      initial_params = {
        language: context.route.query.language,
        native: true,
      }
    }
    // console.log(initial_params)
    // console.log(context.route)
    var url = '/narrators'
    if (context.route.params.category1) {
      url += '/filter/' + context.route.params.category1
    }
    if (context.route.params.category2) {
      url += '/' + context.route.params.category2
    }
    if (context.route.params.category3) {
      url += '/' + context.route.params.category3
    }

    // console.log(url)
    return context.$axios
      .get(url, {
        params: initial_params
      })
      .then((res) => {
        // console.log(res.data)
        return {
          initdata: res.data,
        }
      })
      .catch((e) => {
        context.error({ statusCode: 404 })
      })
  },
}
